export default __webpack_public_path__ + "static/banner-real-stories-saving-spending-lending-ashley-b143dfc97c9035f07bc5977ee14ef4c7.jpg";